// src/pages/ListingsForRent.jsx
import React from "react";
import Listings from "./Listings";

export default function ListingsForRent() {
  return <Listings forcedListingType="rent" />;
}